import { render, staticRenderFns } from "./HelpPopup.vue?vue&type=template&id=4e4d2c20&scoped=true&"
import script from "./HelpPopup.vue?vue&type=script&lang=ts&"
export * from "./HelpPopup.vue?vue&type=script&lang=ts&"
import style0 from "./HelpPopup.vue?vue&type=style&index=0&id=4e4d2c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4d2c20",
  null
  
)

export default component.exports